import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Avatar,
  Box,
  ButtonBase,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography
} from '@mui/material';

// project imports
import { set_logged_in, set_auth_token, set_menu_open } from 'store/actions';
import LogoSection from '../LogoSection';

// assets
import { IconMenu2, IconLogout } from '@tabler/icons';

const mapDispatchToProps = (dispatch) => {
  return {
    setLoggedIn: (data) => dispatch(set_logged_in(data)),
    setAuthToken: (data) => dispatch(set_auth_token(data)),
    setMenuOpen: (data) => dispatch(set_menu_open(data))
  };
};

const Header = ({ handleLeftDrawerToggle, setLoggedIn, setAuthToken, setMenuOpen }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleLogout = async () => {
    sessionStorage.removeItem('isLoggedIn');
    localStorage.removeItem('token');
    setLoggedIn(false);
    setAuthToken('');
    setMenuOpen('default');
    navigate('/login');
  };

  return (
    <>
      <Box
        sx={{
          width: 228,
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto'
          }
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
            <LogoSection />
          </Box>
          <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
            <Avatar
              variant="rounded"
              sx={{
                ...theme.typography.commonAvatar,
                ...theme.typography.mediumAvatar,
                transition: 'all .2s ease-in-out',
                background: theme.palette.secondary.light,
                color: theme.palette.secondary.dark,
                '&:hover': {
                  background: theme.palette.secondary.dark,
                  color: theme.palette.secondary.light
                }
              }}
              onClick={handleLeftDrawerToggle}
              color="inherit"
            >
              <IconMenu2 stroke={1.5} size="1.3rem" />
            </Avatar>
          </ButtonBase>
        </div>
      </Box>

      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />

      <List
        component="nav"
        sx={{
          backgroundColor: theme.palette.background.paper,
          borderRadius: '10px'
        }}
      >
        <ListItemButton
          sx={{
            borderRadius: `12px`,
            '&:hover .MuiTypography-root': {
              color: theme.palette.secondary.dark
            }
          }}
          onClick={handleLogout}
        >
          <ListItemIcon>
            <IconLogout stroke={1.5} size="1.3rem" />
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body2">Logout</Typography>} />
        </ListItemButton>
      </List>
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func,
  setLoggedIn: PropTypes.func,
  setAuthToken: PropTypes.func,
  setMenuOpen: PropTypes.func
};

export default connect(null, mapDispatchToProps)(Header);
